import { h } from 'preact';
import { SelectEntry, TextAreaEntry, TextFieldEntry } from '@epx/flow';

const getScriptTypes = (i18n) => [
  { value: '', label: i18n['opt.none'] || '-- None --' },
  { value: 'JavaScript', label: i18n['opt.JavaScript'] || 'JavaScript' },
  { value: 'Python', label: i18n['opt.Python'] || 'Python' },
  { value: 'CSharp', label: i18n['opt.CSharp'] || 'C#' },
  { value: 'SQL', label: i18n['opt.SQL'] || 'SQL' },
  { value: 'Shell', label: i18n['opt.Shell'] || 'Shell' },
];

export class SfdScriptTaskExtension {
  constructor(lf, i18n) {
    this._lf = lf;
    this._i18n = i18n;
  }

  isApplicable(elementType) {
    return elementType === 'epx:ScriptTask';
  }

  getGroups(element) {
    const lf = this._lf;
    const i18n = this._i18n;
    const props = element.properties || {};
    const id = element.id;

    const update = (key, value) => {
      lf.setProperties(id, { [key]: value });
      lf.emit('node:properties-change', { id, properties: { [key]: value } });
    };

    return [
      {
        id: 'sfdScriptTask',
        label: i18n.sfdScriptTask || 'SFD Script Options',
        entries: [
          {
            id: 'scriptType',
            component: () => (
              <SelectEntry
                id="sfd-scriptType"
                label={i18n.scriptType || 'Script Type'}
                value={props.scriptType || ''}
                options={getScriptTypes(i18n)}
                onChange={(val) => update('scriptType', val)}
              />
            ),
          },
          {
            id: 'scriptArgus',
            component: () => (
              <TextFieldEntry
                id="sfd-scriptArgus"
                label={i18n.argus || 'Arguments'}
                value={props.scriptArgus || ''}
                placeholder="param1;param2"
                debounce={true}
                onChange={(val) => update('scriptArgus', val)}
              />
            ),
          },
          {
            id: 'scriptText',
            component: () => (
              <TextAreaEntry
                id="sfd-scriptText"
                label={i18n.scriptText || 'Script Text'}
                value={props.scriptText || ''}
                onChange={(val) => update('scriptText', val)}
              />
            ),
          },
        ],
      },
    ];
  }
}
